module.exports = __webpack_public_path__ + "img/Stock.0e69ce60.svg";